import React from 'react';
import { Field } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import Fields from 'components/Fields';
import { useFormatMessage } from 'components/IntlProvider';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';

interface CategoryType {
  id: number;
  category: string;
  en_category: string;
}

interface OtherCategoryProps {
  category: CategoryType;
}

const OtherCategory = ({ category }: OtherCategoryProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();

  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t(
          'fields.wizard.audiencegroupsize.p1',
          'You have indicated that you want to test a product from'
        )}{' '}
        <b>{category.en_category}</b>{' '}
        {t(
          'fields.wizard.audiencegroupsize.p2',
          'category. Please provide your category name?'
        )}
      </Typography>
      <Field
        component={Fields.Text}
        variant="outlined"
        margin="normal"
        fullWidth
        label="Your category name"
        name="other_category"
        autoComplete="off"
      />
    </>
  );
};

export default OtherCategory;
